module.exports = __webpack_public_path__ + "static/media/chamath_palihapitiya_keynote.02b674cc.png";